export function buildProfileFormData({
     firstName,
     lastName,
     phoneCode,
     phoneNumber,
     birthDate,
     majorId,
     academicDegreeId,
     specializationId,
     experienceYears,
     email,
     language,
     bio,
     image,
}) {
     const formData = new FormData();

     formData.append('first_name', firstName);
     formData.append('last_name', lastName);
     if (bio != null) formData.append('bio', bio);
     if (image) formData.append('image', image);
     formData.append('phone_code', phoneCode);
     formData.append('phone', phoneNumber);
     formData.append('birth_date', birthDate);
     if (majorId !== undefined && majorId !== null && majorId !== '') formData.append('major_id', majorId);
     if (academicDegreeId !== undefined && academicDegreeId !== null && academicDegreeId !== '') formData.append('academic_degree_id', academicDegreeId);
     if (specializationId !== undefined && specializationId !== null && specializationId !== '') formData.append('specialization_id', specializationId);
     if (experienceYears !== undefined && experienceYears !== null && experienceYears !== '') formData.append('experience_years', experienceYears);
     formData.append('email', email);
     formData.append('language', language);

     return formData;
}